import React, {useEffect, useState} from 'react'
import '../assets/css/Panel.css'
import Navbar from "../components/Navbar";
import ExamCard from "../components/ExamCard";
import GashtaltImage from '../assets/images/gavazn.png'
import {useNavigate} from "react-router-dom";
import {api} from "../utils/gashtaltAPI";
import Loader from "../components/Loader";
import {useDispatch} from "react-redux";
import FileCard from "../components/FileCard";

function Files() {
    const [exams, setExams] = useState([]);
    const [loading,setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await api.get('/api/bundle/all')
                setExams(response.data.data);
            } catch (error) {

            }finally {
                setLoading(false);
            }
        }
        fetchData();
    }, []);

    if (loading) return <Loader />
    return (
        <div className="d-flex flex-column h-100">
            <Navbar/>
            <div className="cards-container row flex-fill justify-content-center align-items-center">
                {exams.length===0 && (
                    <h1 className="text-center">فایلی یافت نشد!</h1>
                )}
                {exams.map((exam, index) => (
                    <FileCard Image={GashtaltImage} id={exam.id} description={exam.description} name={exam.name} files={exam.files} downloadable={exam.is_downloadable}  hasPaid={exam.hasPaidBundle} price={exam.total_price}/>
                ))}
            </div>
        </div>
    );
}

export default Files;
